import React, { useReducer, useContext, useEffect } from "react";
import TradathonContext from "./TradathonContext";
import TradathonReducer from "./TradathonReducer";
import AuthContext from "../auth/authContext";
import isTokenExpired from "../../helpers/jwtHelper";
import axios from "axios";
import dotenv from "dotenv";
import CryptoContext from "../crypto/cryptoContext";
import ParameterContext from "../parameter/parameterContext";
import {
  TRADATHON_GET_COINS,
  TRADATHON_CREATE_ROOM,
  TRADATHON_CREATE_ROOM_ERROR,
  TRADATHON_ADD_COINS,
  TRADATHON_ADD_COINS_ERROR,
  GET_LIVE_CONTESTS,
  SET_ACTIVE_ROOM,
  TOGGLE_TRADATHON_ALERT_MODAL,
  SET_COIN_CST_AMOUNT,
  TRADATHON_DELETE_COINS,
  TRADATHON_EDIT_COINS,
  TRADATHON_SET_ACTIVE_CRYPTO_IN_VT,
  TRADATHON_CLEAR_COINS_DATA,
  TRADATHON_PLACE_ORDER_IN_VT,
  TRADATHON_PLACE_SELL_ORDER,
  TRADATHON_PLACE_ORDER_IN_VT_ERROR,
  TRADATHON_GET_PARTICULAR_PORTFOLIO_IN_VT,
  TRADATHON_SET_SELL_TYPE_IN_VT,
  TRADATHON_SET_ACTIVE_PRICE,
  TRADATHON_MODIFY_ORDER_IN_VT,
  TRADATHON_CANCEL_ORDER_IN_VT,
  TRADATHON_SET_SELL_PRICE_FOR_STOP_LIMIT,
  CLEAR_ROOM_DATA,
  TRADATHON_GET_LIVE_CONTEST_COINS,
  GET_LEADERBOARD_OF_CONTEST,
  TRADATHON_SET_TOTAL_CURRENT_AMOUNT,
  TRADATHON_SET_NET_PL,
  TRADATHON_SET_TOTAL_INV_AMOUNT,
  PAY_FOR_TRADATHON,
  CLEAR_TRADATHON_ERROR,
  CLEAR_TRADATHON_MESSAGE,
  STOP_TRADATHON_LOADING,
  START_TRADATHON_LOADING,
  GET_WINNINGS,
  CLEAR_LEADERBOARD,
  CHANGE_BALANCE,
  TRADATHON_CLEAR_CONTESTS,
  TRADATHON_CLEAR_WINNINGS,
  SET_FCM_TOKEN,
  GET_ROOM,
  START_TRADATHON_ROOM_LOADING,
  STOP_TRADATHON_ROOM_LOADING,
  CHECK_USER_JOINED,GET_WINNINGS_DISTRIBUTION,SET_USER_JOINED,
  START_JOINING,
  STOP_JOINING
} from "../types";
dotenv.config();
const getActiveRoomFromLocalStorage = localStorage.getItem("activeRoom")
  ? JSON.parse(localStorage.getItem("activeRoom"))
  : null;
const getActiveItemForSellFromLocalStorage = localStorage.getItem(
  "activeItemForSell"
)
  ? JSON.parse(localStorage.getItem("activeItemForSell"))
  : null;

const TradathonState = ({ children }) => {
  const initialState = {
    createRoomData: null,
    contests: null,
    publicContests: null,
    activeRoom: getActiveRoomFromLocalStorage,
    coins: null,
    tradathonModal: false,
    coinCSTAmount: null,
    tradathon_activeCrypto: getActiveItemForSellFromLocalStorage,
    tradathon_activePortID: 1,
    tradathon_orderDetails: null,
    tradathon_vtradingError: null,
    tradathon_singlePortfolio: null,
    tradathon_portId: null,
    tradathon_orderType: "buy",
    tradathon_coinsData: null,
    tradathon_currentPortIDDetails: [],
    tradathon_activePrice: null,
    tradathon_vtradingAlertModal: false,
    tradathon_sellPrice: null,
    tradathon_invAmount: null,
    tradathon_currentAmount: null,
    tradathon_netPL: null,
    tradathon_vtradingMessage: null,
    tradathon_PCSTAmount: null,
    tradathon_alreadyInvested: [],
    tradathonLoading: false,
    tradathon_count: 0,
    contestCoins: null,
    leaderboard: null,
    winnings: null,
    dummyBalance: 0,
    openOrderCoins: null,
    historyCoins: null,
    roomDetails: null,
    tradathonRoomLoading: false,
    joinedRoom:false,
    joiningLoading:false
  };
  const { token, logoutUser, userData, getAmountInWallet } =
    useContext(AuthContext);
  const [state, dispatch] = useReducer(TradathonReducer, initialState);
  const {
    vtButton,
    placeOrderType,
    activePortfolio,
    setActiveRoomId,
    listingTab,
  } = useContext(ParameterContext);
  const { livePriceData, exchangeRate } = useContext(CryptoContext);

  useEffect(() => {
    let coinPrice =
      livePriceData && livePriceData[state.tradathon_activeCrypto.symbol];

    if (placeOrderType === "market") {
      tradathon_setActiveCrypto({
        ...state.tradathon_activeCrypto,
        price: coinPrice,
      });
    }
    tradathon_setActivePrice({
      ...state.tradathon_activePrice,
      price: coinPrice,
    });

    //eslint-disable-next-line
  }, [livePriceData]);
  const config = {
    headers: {
      "Content-Type": "application/json",
      "x-auth-token": token,
    },
  };
  const handleLogout = () => {
    if (token && isTokenExpired(token)) {
      logoutUser();
    }
  };
  const createRoom = async (formData) => {
    dispatch({ type: START_TRADATHON_ROOM_LOADING });
    handleLogout();

    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_TRADATHON}/room/create`,
        {
          ...formData,
          startTime: formData.startTime.toISOString(),
          endTime: formData.endTime.toISOString(),
          noOfWinners: Number(formData.noOfWinners),
          noOfPlayers: Number(formData.noOfPlayers),
        },
        config
      );

      dispatch({ type: TRADATHON_CREATE_ROOM, payload: data });
    } catch (err) {
      dispatch({
        type: TRADATHON_CREATE_ROOM_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    dispatch({ type: STOP_TRADATHON_ROOM_LOADING });
  };
  const joinRoom = async (formData) => {
    dispatch({ type: START_TRADATHON_ROOM_LOADING });
    handleLogout();

    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_TRADATHON}/room/join`,
        formData,
        config
      );
      dispatch({ type: TRADATHON_CREATE_ROOM, payload: data, from: "join" });
    } catch (err) {
      dispatch({
        type: TRADATHON_CREATE_ROOM_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
        from:
          formData.from === "publicContestModal"
            ? "publicContestModal"
            : "join",
      });
    }
    dispatch({ type: STOP_TRADATHON_ROOM_LOADING });
  };
  const addCoins = async (formData) => {
    // if (state.coins && state.coins.length < 20) {
    let formData1 = formData.coins?.map((c) => {
      return { ...c, cstAmount: c.cstAmount * exchangeRate };
    });
    handleLogout();

    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_TRADATHON}/tradathon/addcoins`,
        { ...formData, coins: formData1 },
        config
      );

      dispatch({ type: TRADATHON_ADD_COINS, payload: data });
    } catch (err) {
      dispatch({
        type: TRADATHON_ADD_COINS_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    if (
      state.activeRoom &&
      (state.activeRoom.room.rstatus === 0 ||
        state.activeRoom.room.rstatus === 1)
    ) {
      getContests("live");
    }
    // } else {
    //   toast.error(
    //     "You have reached the limit, You cannot have more than 20 items"
    //   );
    // }
  };

  const getCoins = async (rmid) => {
    dispatch({ type: START_TRADATHON_LOADING });
    handleLogout();

    const url = `${process.env.REACT_APP_TRADATHON}/tradathon/getcoins?rmid=${rmid}&rid=${state.activeRoom.rid}`;

    try {
      const { data } = await axios.get(url, config);

      dispatch({ type: TRADATHON_GET_COINS, payload: data, vtButton });
      dispatch({ type: STOP_TRADATHON_LOADING });
    } catch (err) {
      dispatch({
        type: TRADATHON_ADD_COINS_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const getContests = async (status, type = "private") => {
    dispatch({ type: START_TRADATHON_LOADING, contestType: listingTab });
    handleLogout();

    try {
      let url =
        type === "private"
          ? status === "live"
            ? `${process.env.REACT_APP_TRADATHON}/room/liveRooms?pid=${userData.profile_data._id}`
            : `${process.env.REACT_APP_TRADATHON}/room/userRooms?pid=${userData.profile_data._id}&status=${status}`
          : `${process.env.REACT_APP_TRADATHON}/room/showRooms?status=${status}`;
      const { data } = await axios.get(url, config);

      dispatch({
        type: GET_LIVE_CONTESTS,
        payload: data,
        contestType: listingTab,
      });
      dispatch({ type: STOP_TRADATHON_LOADING });
    } catch (err) {
      dispatch({
        type: TRADATHON_ADD_COINS_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const editCoins = async (amount) => {
    dispatch({ type: START_TRADATHON_LOADING });
    handleLogout();

    try {
      const { data } = await axios.put(
        `${process.env.REACT_APP_TRADATHON}/tradathon/editcoin`,
        {
          rmid: state.activeRoom._id,
          rid: state.activeRoom.rid,
          coinId: state.coinCSTAmount.coinId,
          cstAmount: amount * exchangeRate,
        },
        config
      );

      dispatch({ type: TRADATHON_EDIT_COINS, payload: data });
      dispatch({ type: STOP_TRADATHON_LOADING });
    } catch (err) {
      dispatch({
        type: TRADATHON_ADD_COINS_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    if (state.activeRoom) {
      vtButton === "position"
        ? getCoins(state.activeRoom._id)
        : getCoinsInCurrentContest(state.activeRoom._id, state.activeRoom.rid);
    }
  };
  const deleteCoins = async (coinId) => {
    dispatch({ type: START_TRADATHON_LOADING });
    handleLogout();

    try {
      const { data } = await axios.delete(
        `${process.env.REACT_APP_TRADATHON}/tradathon/deletecoins?coinId=${coinId}`,
        config
      );

      dispatch({ type: TRADATHON_DELETE_COINS, payload: data });
      dispatch({ type: STOP_TRADATHON_LOADING });
    } catch (err) {
      dispatch({
        type: TRADATHON_ADD_COINS_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    if (state.activeRoom) {
      vtButton === "position"
        ? getCoins(state.activeRoom._id)
        : getCoinsInCurrentContest(state.activeRoom._id, state.activeRoom.rid);
    }
  };

  const setActiveRoom = (data) => {
    dispatch({ type: SET_ACTIVE_ROOM, payload: data });
    setActiveRoomId(data.rid);
  };
  const toggleTradathonModal = () => {
    dispatch({ type: TOGGLE_TRADATHON_ALERT_MODAL });
  };
  const setCoinCSTAmount = (data) => {
    dispatch({ type: SET_COIN_CST_AMOUNT, payload: data });
  };

  const tradathon_setActiveCrypto = (data) => {
    dispatch({ type: TRADATHON_SET_ACTIVE_CRYPTO_IN_VT, payload: data });
  };

  const tradathon_setSellType = (type) => {
    dispatch({ type: TRADATHON_SET_SELL_TYPE_IN_VT, payload: type });
  };
  const tradathon_placeMarketBuyOrder = async (total, p = 1) => {
    // dispatch({ type: START_VTRADING_LOADING})
    try {
      if (token && isTokenExpired(token)) {
        logoutUser();
      }

      const config = {
        headers: {
          "x-auth-token": token,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_TRADATHON}/tradathon/placeBuyMarketOrder`,
        {
          symbol: state.tradathon_activeCrypto.symbol,
          type: state.tradathon_orderType,
          rmid: state.activeRoom._id,
          rid: state.activeRoom.rid,
          total: total * exchangeRate,
        },
        config
      );
      //place order in vt

      dispatch({
        type: TRADATHON_PLACE_ORDER_IN_VT,
        payload: data,
        show: p === 1 ? true : false,
      });
    } catch (err) {
      dispatch({
        type: TRADATHON_PLACE_ORDER_IN_VT_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    if (state.activeRoom) {
      vtButton === "position"
        ? getCoins(state.activeRoom._id)
        : getCoinsInCurrentContest(state.activeRoom._id, state.activeRoom.rid);
    }

    // dispatch({ type: STOP_VTRADING_LOADING})
  };

  const tradathon_placeMarketSellOrder = async (amount, p = 1) => {
    // dispatch({ type: START_VTRADING_LOADING})
    try {
      if (token && isTokenExpired(token)) {
        logoutUser();
      }

      const config = {
        headers: {
          "x-auth-token": token,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_TRADATHON}/tradathon/placeSellMarketOrder`,
        {
          symbol: state.tradathon_activeCrypto.symbol,
          type: state.tradathon_orderType,
          rmid: state.activeRoom._id,
          rid: state.activeRoom.rid,
          quantity: amount,
        },
        config
      );

      //place order in vt
      dispatch({
        type: TRADATHON_PLACE_ORDER_IN_VT,
        payload: data,
        show: p === 1 ? true : false,
      });
    } catch (err) {
      dispatch({
        type: TRADATHON_PLACE_ORDER_IN_VT_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    if (state.activeRoom) {
      vtButton === "position"
        ? getCoins(state.activeRoom._id)
        : getCoinsInCurrentContest(state.activeRoom._id, state.activeRoom.rid);
    }

    // dispatch({ type: STOP_VTRADING_LOADING})
  };

  //doubt
  const tradathon_placeOrder = async (amount, price, p = 1) => {
    // dispatch({ type: START_VTRADING_LOADING})

    // if (state.coins && state.coins.length < 20) {
    try {
      if (token && isTokenExpired(token)) {
        logoutUser();
      }

      const config = {
        headers: {
          "x-auth-token": token,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_TRADATHON}/tradathon/placeOrder`,
        {
          symbol: state.tradathon_activeCrypto.symbol,
          price: price * exchangeRate,
          type: state.tradathon_orderType,
          rmid: state.activeRoom._id,
          rid: state.activeRoom.rid,
          quantity: amount,
        },
        config
      );
      //place order in vt
      dispatch({
        type: TRADATHON_PLACE_ORDER_IN_VT,
        payload: data,
        show: p === 1 ? true : false,
      });
    } catch (err) {
      dispatch({
        type: TRADATHON_PLACE_ORDER_IN_VT_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    if (state.activeRoom) {
      vtButton === "position"
        ? getCoins(state.activeRoom._id)
        : getCoinsInCurrentContest(state.activeRoom._id, state.activeRoom.rid);
    }
    // }
    //  else {
    //   toast.error(
    //     "You have reached the limit, You cannot have more than 20 items"
    //   );
    // }

    // dispatch({ type: STOP_VTRADING_LOADING})
  };
  const tradathon_placeStoplimitOrder = async (
    amount,
    buyPrice,
    sellPrice,
    p = 1
  ) => {
    // dispatch({ type: START_VTRADING_LOADING})

    try {
      if (token && isTokenExpired(token)) {
        logoutUser();
      }

      const config = {
        headers: {
          "x-auth-token": token,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_TRADATHON}/tradathon/placestoplimitorder`,
        {
          sellprice: sellPrice * exchangeRate,
          buyprice: buyPrice * exchangeRate,
          amount: amount,
          portId: state.portId,
          symbol: state.activeCrypto.symbol,
        },
        config
      );

      dispatch({
        type: TRADATHON_PLACE_SELL_ORDER,
        payload: data,
        show: p === 1 ? true : false,
      });
    } catch (err) {
      dispatch({
        type: TRADATHON_PLACE_ORDER_IN_VT_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    if (state.activeRoom) {
      vtButton === "position"
        ? getCoins(state.activeRoom._id)
        : getCoinsInCurrentContest(state.activeRoom._id, state.activeRoom.rid);
    }

    // dispatch({ type: STOP_VTRADING_LOADING})
  };
  const tradathon_getParticularPortfolio = async (
    pid_number = activePortfolio
  ) => {
    try {
      if (token && isTokenExpired(token)) {
        logoutUser();
      }
      const config = {
        headers: {
          "x-auth-token": token,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_TRADATHON}/tradathon/getPortfolio?serno=${pid_number}`,
        config
      );
      dispatch({
        type: TRADATHON_GET_PARTICULAR_PORTFOLIO_IN_VT,
        payload: data,
      });
      // console.log(JSON.stringify(data) + " vt");
    } catch (err) {
      dispatch({
        type: TRADATHON_PLACE_ORDER_IN_VT_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const getCoinsInCurrentContest = async (rmid, rid) => {
    dispatch({ type: START_TRADATHON_LOADING });
    try {
      if (token && isTokenExpired(token)) {
        logoutUser();
      }
      const config = {
        headers: {
          "x-auth-token": token,
        },
      };
      const url =
        vtButton === "history"
          ? `${process.env.REACT_APP_TRADATHON}/tradathon/getPlacedOrderHistory?rmid=${state.activeRoom._id}&rid=${state.activeRoom.rid}`
          : `${process.env.REACT_APP_TRADATHON}/tradathon/getOpenOrder?rmid=${state.activeRoom._id}&rid=${state.activeRoom.rid}`;
      const { data } = await axios.get(url, config);
      dispatch({
        type: TRADATHON_GET_LIVE_CONTEST_COINS,
        payload: data,
        vtButton,
      });
      dispatch({ type: STOP_TRADATHON_LOADING });
      // console.log(JSON.stringify(data) + " vt");
    } catch (err) {
      dispatch({
        type: TRADATHON_PLACE_ORDER_IN_VT_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };

  const tradathon_setActivePrice = (price) => {
    dispatch({ type: TRADATHON_SET_ACTIVE_PRICE, payload: price });
  };

  const tradathon_setSellPrice = (price) => {
    dispatch({ type: TRADATHON_SET_SELL_PRICE_FOR_STOP_LIMIT, payload: price });
  };
  const tradathon_cancelOrder = async (orderid, p = 1) => {
    // dispatch({ type: START_VTRADING_LOADING})
    dispatch({ type: START_TRADATHON_LOADING });

    try {
      if (token && isTokenExpired(token)) {
        logoutUser();
      }

      const config = {
        headers: {
          "x-auth-token": token,
        },
      };
      const { data } = await axios.put(
        `${process.env.REACT_APP_TRADATHON}/tradathon/cancelOrder?orderid=${orderid}`,
        {},
        config
      );
      //Cancel order in vt
      dispatch({
        type: TRADATHON_CANCEL_ORDER_IN_VT,
        payload: data,
        show: p === 1 ? true : false,
      });
      p === 1 && dispatch({ type: STOP_TRADATHON_LOADING });
    } catch (err) {
      dispatch({
        type: TRADATHON_PLACE_ORDER_IN_VT_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    // dispatch({ type: STOP_VTRADING_LOADING})
    if (state.activeRoom) {
      vtButton === "position"
        ? getCoins(state.activeRoom._id)
        : getCoinsInCurrentContest(state.activeRoom._id, state.activeRoom.rid);
    }
  };
  const tradathon_modifyOrder = async (a, amount) => {
    dispatch({ type: START_TRADATHON_LOADING });
    if (placeOrderType === "market") {
      tradathon_cancelOrder(state.tradathon_activePrice.orderId, 2);
      if (state.tradathon_orderType === "sell") {
        tradathon_placeMarketSellOrder(a, 2);
      } else if (state.tradathon_orderType === "buy") {
        tradathon_placeMarketBuyOrder(a, 2);
      }
      // {
      //   symbol: state.tradathon_activeCrypto.symbol,
      //   type: state.tradathon_orderType,
      //   rmid: state.activeRoom._id,
      //   rid: state.activeRoom.rid,
      //   total: total * exchangeRate,
      // }
    } else {
      try {
        if (token && isTokenExpired(token)) {
          logoutUser();
        }

        const config = {
          headers: {
            "x-auth-token": token,
          },
        };
        const { data } = await axios.post(
          `${process.env.REACT_APP_TRADATHON}/tradathon/modifyOrder`,
          {
            orderid: state.tradathon_activePrice.orderId,
            quantity: amount,
          },
          config
        );
        //place order in vt
        dispatch({ type: TRADATHON_MODIFY_ORDER_IN_VT, payload: data });
        dispatch({ type: STOP_TRADATHON_LOADING });
      } catch (err) {
        dispatch({
          type: TRADATHON_PLACE_ORDER_IN_VT_ERROR,
          payload:
            err.response && err.response.data.message
              ? err.response.data.message
              : err.message,
        });
      }
    }

    // dispatch({ type: STOP_VTRADING_LOADING})
    if (state.activeRoom) {
      vtButton === "position"
        ? getCoins(state.activeRoom._id)
        : getCoinsInCurrentContest(state.activeRoom._id, state.activeRoom.rid);
    }
  };

  const tradathon_clearCoinsData = () => {
    dispatch({ type: TRADATHON_CLEAR_COINS_DATA });
  };
  const setLeaderboardOfContest = (data) => {
    dispatch({ type: GET_LEADERBOARD_OF_CONTEST, payload: data });
  };
  const getLeaderboardOfContest = async (rid) => {
    dispatch({ type: START_TRADATHON_LOADING });
    try {
      if (token && isTokenExpired(token)) {
        logoutUser();
      }

      const config = {
        headers: {
          "x-auth-token": token,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_TRADATHON}/tradathon/leaderboard?rid=${rid}`,
        config
      );
      //place order in vt
      dispatch({ type: GET_LEADERBOARD_OF_CONTEST, payload: data.data });
      dispatch({ type: STOP_TRADATHON_LOADING });
    } catch (err) {
      dispatch({
        type: TRADATHON_PLACE_ORDER_IN_VT_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };

  const tradathon_setTotalInvAmount = (data) => {
    dispatch({ type: TRADATHON_SET_TOTAL_INV_AMOUNT, payload: data });
  };
  const tradathon_setTotalCurrentAmount = (data) => {
    dispatch({ type: TRADATHON_SET_TOTAL_CURRENT_AMOUNT, payload: data });
  };
  const tradathon_setTotalNetPL = (data) => {
    dispatch({ type: TRADATHON_SET_NET_PL, payload: data });
  };
  const payForTradathon = async () => {
    dispatch({ type: START_TRADATHON_LOADING });
    handleLogout();

    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_TRADATHON}/tradathonPayment/createOrderPayment`,
        {
          rmid: state.activeRoom._id,
          rid: state.activeRoom.rid,
          pid: userData.profile_data._id,
        },
        config
      );

      dispatch({ type: PAY_FOR_TRADATHON, payload: data });
      dispatch({ type: STOP_TRADATHON_LOADING });
      getAmountInWallet();
    } catch (err) {
      dispatch({
        type: TRADATHON_ADD_COINS_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const clearRoomData = () => {
    dispatch({ type: CLEAR_ROOM_DATA });
  };
  const clearTradathonError = () => {
    dispatch({ type: CLEAR_TRADATHON_ERROR });
  };
  const clearTradathonMessage = () => {
    dispatch({ type: CLEAR_TRADATHON_MESSAGE });
  };
  const getWinnings = async (rid) => {
    dispatch({ type: START_TRADATHON_LOADING });
    handleLogout();

    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_TRADATHON}/tradathon/winning?rid=${rid}`,
        config
      );

      dispatch({ type: GET_WINNINGS, payload: data });
      dispatch({ type: STOP_TRADATHON_LOADING });
      getAmountInWallet();
    } catch (err) {
      dispatch({
        type: TRADATHON_ADD_COINS_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const clearLeaderboard = () => {
    dispatch({ type: CLEAR_LEADERBOARD });
  };
  const changeBalance = (amount) => {
    dispatch({ type: CHANGE_BALANCE, payload: amount });
  };
  const clearContests = () => {
    dispatch({ type: TRADATHON_CLEAR_CONTESTS });
  };
  const clearWinnings = () => {
    dispatch({ type: TRADATHON_CLEAR_WINNINGS });
  };
  const setFCMToken = () => {
    dispatch({ type: SET_FCM_TOKEN });
  };
  const getRoom = async (rcode) => {
    dispatch({ type: START_TRADATHON_LOADING });
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_TRADATHON}/room/checkRoom?rcode=${rcode}`,
        config
      );
      dispatch({ type: GET_ROOM, payload: data });
      dispatch({ type: STOP_TRADATHON_LOADING });
    } catch (err) {
      dispatch({
        type: TRADATHON_ADD_COINS_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const checkUserJoined=async(rid) => {
    dispatch({ type: START_JOINING})
dispatch({type:SET_USER_JOINED})
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_TRADATHON}/room/checkUserJoined?pid=${userData.profile_data._id}&rid=${rid}`,
        config
      );
      dispatch({ type: CHECK_USER_JOINED, payload: data });
      
    } catch (err) {
      dispatch({
        type: TRADATHON_ADD_COINS_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    dispatch({ type:STOP_JOINING})
  }
  const getWinningsDistribution=async(formData)=>{
    dispatch({ type: START_TRADATHON_LOADING });
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_TRADATHON}/tradathon/winning`,formData,
        config
      );
      dispatch({ type: GET_WINNINGS_DISTRIBUTION, payload: data });
      
    } catch (err) {
      dispatch({
        type: TRADATHON_ADD_COINS_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    } 
    dispatch({ type: STOP_TRADATHON_LOADING });
  }
  const setUserJoined=() => {
    dispatch({ type:SET_USER_JOINED})
  }
  return (
    <TradathonContext.Provider
      value={{
        checkUserJoined,
        dummyBalance: state.dummyBalance,
        createRoomData: state.createRoomData,
        contests: state.contests,
        publicContests: state.publicContests,
        activeRoom: state.activeRoom,
        coins: state.coins,
        tradathonModal: state.tradathonModal,
        coinCSTAmount: state.coinCSTAmount,
        openOrderCoins: state.openOrderCoins,
        historyCoins: state.historyCoins,
        winnings: state.winnings,
        roomDetails: state.roomDetails,
        tradathon_activeCrypto: state.tradathon_activeCrypto,
        tradathon_activePortID: state.tradathon_activePortID,
        tradathon_orderDetails: state.tradathon_orderDetails,
        tradathon_vtradingError: state.tradathon_vtradingError,
        tradathon_singlePortfolio: state.tradathon_singlePortfolio,
        tradathon_portId: state.tradathon_portId,
        tradathon_orderType: state.tradathon_orderType,
        tradathon_coinsData: state.tradathon_coinsData,
        tradathon_currentPortIDDetails: state.tradathon_currentPortIDDetails,
        tradathon_activePrice: state.tradathon_activePrice,
        tradathon_sellPrice: state.tradathon_sellPrice,
        tradathon_invAmount: state.tradathon_invAmount,
        tradathon_currentAmount: state.tradathon_currentAmount,
        tradathon_netPL: state.tradathon_netPL,
        tradathon_vtradingMessage: state.tradathon_vtradingMessage,
        tradathon_PCSTAmount: state.tradathon_PCSTAmount,
        tradathon_alreadyInvested: state.tradathon_alreadyInvested,
        tradathonLoading: state.tradathonLoading,
        tradathon_count: state.tradathon_count,
        contestCoins: state.contestCoins,
        leaderboard: state.leaderboard,
        tradathonRoomLoading: state.tradathonRoomLoading,
        getLeaderboardOfContest,
        getCoinsInCurrentContest,
        payForTradathon,
        clearTradathonError,
        clearTradathonMessage,
        setLeaderboardOfContest,

        clearLeaderboard,
        clearWinnings,
        editCoins,
        deleteCoins,
        tradathon_clearCoinsData,
        tradathon_modifyOrder,
        tradathon_cancelOrder,
        tradathon_setSellPrice,
        tradathon_placeStoplimitOrder,
        tradathon_getParticularPortfolio,
        tradathon_setActivePrice,
        tradathon_setActiveCrypto,
        tradathon_setSellType,
        tradathon_placeOrder,
        tradathon_placeMarketSellOrder,
        tradathon_placeMarketBuyOrder,
        getWinnings,
        setFCMToken,
        addCoins,
        getContests,
        toggleTradathonModal,
        setCoinCSTAmount,
        tradathon_setTotalNetPL,
        tradathon_setTotalInvAmount,
        tradathon_setTotalCurrentAmount,
        clearRoomData,
        createRoom,
        changeBalance,
        joinRoom,
        setActiveRoom,
        clearContests,
        getRoom,
        getCoins,
        joinedRoom:state.joinedRoom,
        getWinningsDistribution,setUserJoined,
        joiningLoading:state.joiningLoading
      }}
    >
      {children}
    </TradathonContext.Provider>
  );
};

export default TradathonState;
